import Card from "../ui/Card";
import { useCashierText } from "./cashierText";

const cards = ["total", "complete", "pending", "deleted"];
export default function CashierSummary({ summary = {} }) {
  const { t } = useCashierText();
  return (
    <div className="cashier-stats">
      {cards.map((key) => (
        <Card
          className="cashier-stat"
          hoverable={false}
          key={key}
          padding="sm"
        >
          <span>{t.summary[key]}</span>
          <b>{summary[key] || 0}</b>
        </Card>
      ))}
    </div>
  );
}
